var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Button } from "./Button";
export const SubmittingButton = forwardRef((_a, ref) => {
    var { disabled, type = "saving", loading, children, sx, _type = "submit" } = _a, props = __rest(_a, ["disabled", "type", "loading", "children", "sx", "_type"]);
    return (React.createElement(Button, Object.assign({ ref: ref, disabled: disabled || loading, type: _type, sx: Object.assign({ cursor: loading ? "not-allowed" : "pointer", textTransform: loading ? "capitalize" : undefined }, sx) }, props), loading ? `${type}...` : children));
});
//# sourceMappingURL=SubmittingButton.js.map